import React, { useEffect, useState, useContext } from 'react';
import { formatDate } from '../../../Util/timezone';

// MUI
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// actions
import {
  updateProductStatus,
  setProductDescription,
} from '../../../Actions';
import { AlertContext } from '../../../Context/AlertContextProvider';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { Divider } from '@material-ui/core';

// component
export default function UpdateProductDialog(props) {
  const { handleAlertOpen, setMessageType, setMessage } =
    useContext(AlertContext);

  const [selectedOption, setSelectedOption] = useState();
  const [isProductActive, setIsProductActive] = useState(false);
  const [isOptionActive, setIsOptionActive] = useState(false);
  const [discontinueDate, setDiscontinueDate] = useState();
  const [description, setDescription] = useState();
  const [image, setImage] = useState();

  // TODO: Add this in later. Image link for each individual product SKU/cost Id
  // const [optionImage, setOptionImage] = useState();

  useEffect(() => {
    if (!props.isOpen) return;

    if (props.product?.product_uuid) {
      setDescription(props.product?.product_description);
      setImage(props.product?.product_image);
    }

    setIsProductActive(props.product?.options.find(o => !o.effective_end_date || o.effective_end_date === '9999-12-31') ? 1 : 0);

  }, [props.product?.product_uuid, props.isOpen]);

  useEffect(() => {
    if (!props.isOpen) return;

    if (selectedOption?.cost_id) {
      setDiscontinueDate(selectedOption.effective_end_date);
      setIsOptionActive(!selectedOption.is_discontinued ? 1 : 0);
      
      // TODO: Add this in later. Image link for each individual product SKU/cost Id
      //setOptionImage(selectedOption.product_sku_image);
    }

  }, [selectedOption?.cost_id, props.isOpen])

  useEffect(() => {
    setIsProductActive(props.product?.options.find(o => !o.effective_end_date || o.effective_end_date === '9999-12-31') ? 1 : 0);
  }, [props.product?.options])

  const clearDialog = async () => {
    setSelectedOption(undefined);
    setDiscontinueDate(undefined);
    setIsProductActive(0);
    setDescription(props.product?.product_description);
    setImage(props.product?.product_image);

    props.handleOnClose();
  }

  const handleProductSubmit = async () => {
    await setProductDescription(description, image, props.product?.product_uuid)
      .then(() => {
        setMessageType('success');
        setMessage('Link to product description updated!');
        handleAlertOpen();
        
        props.handleOnSubmit();
      })
      .catch(() => {
        setMessageType('error');
        setMessage('Error setting link to product description!');
        handleAlertOpen();
      });
  };

  // TODO: Add this in later. Image link for each individual product SKU/cost Id
  // const handleOptionSubmit = async () => {
  //   return;
  // }

  const handleIsProductActiveChange = async (value) => {
    if (!value) return;

    setIsProductActive(value === 'on' ? 1 : 0);
    setIsOptionActive(value === 'on' ? 1 : 0);

    if (value === 'on') { 
      setDiscontinueDate(undefined);
    }

    await updateProductStatus(undefined, props.product?.product_uuid, value === 'on' ? 1 : 0).then(response => {
      setDiscontinueDate(response.data.discontinue_date);
      
      setMessageType('success');
      setMessage('Successfully updated discontinue date!');
      handleAlertOpen();

      props.handleOnSubmit();

    }).catch(() => {
      setMessageType('error');
      setMessage('Error updating discontinue date!');
      handleAlertOpen();
    });
  };

  const handleIsProductOptionActiveChange = async (value) => {
    if (!value) return;

    setIsOptionActive(value === 'on' ? 1 : 0);

    await updateProductStatus(selectedOption?.cost_id, props.product?.product_uuid, value === 'on' ? 1 : 0).then(response => {
      setDiscontinueDate(response.data.discontinue_date);

      setMessageType('success');
      setMessage('Successfully updated discontinue date!');
      handleAlertOpen();

      props.handleOnSubmit();

    }).catch(() => {
      setMessageType('error');
      setMessage('Error updating discontinue date!');
      handleAlertOpen();
    });
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={() => clearDialog()}
      maxWidth="md"
      aria-labelledby="Edit Product Dialog"
      aria-describedby="Edit Product Dialog"
    >
      <div id="alert-dialog-title" style={{padding: "15px"}}>
        <Typography variant="h4" style={{display: "inline-block", verticalAlign: "middle", color: "#28C4FC"}}>
          Edit Product
        </Typography>
        <div style={{display: "inline-block", verticalAlign: "middle", float: "right"}}>
          <Button
            variant="outlined"
            onClick={() => clearDialog()}
            className="product__pending-header-button"
            style={{}}
          >
            X
          </Button>
        </div>
      </div>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography><b>{props.product?.trade_name}</b></Typography>
            <Typography style={{margin: "15px 0px 0px"}}>Product Description Link</Typography>
            <TextField
              name="description"
              type="text"
              label="Link to product description"
              value={description || ''}
              fullWidth
              variant="filled"
              onChange={(e) => setDescription(e.target.value)}
            />
            <Typography style={{margin: "15px 0px 0px"}}>Product Image Link</Typography>
            <TextField
              name="image"
              type="text"
              label="Link to main product image"
              value={image || ''}
              fullWidth
              variant="filled"
              onChange={(e) => setImage(e.target.value)}
            /> 
          </Grid>
          <Grid item xs={12} style={{textAlign: "right"}}>
            <Button
              onClick={() => handleProductSubmit()}
              variant="contained"
              style={{backgroundColor: "#4caf50", color: "#FFFFFF"}}
            >
              Update Product Links
            </Button>
          </Grid>
          <Grid item xs={12}>
            <ToggleButtonGroup
              value={isProductActive ? 'on' : 'off'}
              exclusive
              size='small'
              onChange={(e, newValue) => handleIsProductActiveChange(newValue)}
              aria-label="text alignment"
              style={{display: "inline-block", margin: "15px 0px 0px"}}
            >
              <ToggleButton value='on' aria-label="activate product" style={isProductActive ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                Yes
              </ToggleButton>
              <ToggleButton value='off' aria-label="discontinue product" style={!isProductActive ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                No
              </ToggleButton>
            </ToggleButtonGroup>
            <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
              Is Product Active?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider style={{margin: "15px auto"}}/>
          </Grid>
          <Grid item xs={12}>
            <>
              <Typography>
                <b>Options</b>
              </Typography>
              <Select
                value={selectedOption?.cost_id ?? ""}
                onChange={(e) => {
                  const option = props.product?.options?.find(option => option.cost_id === e.target.value);

                  setSelectedOption({ ...option });
                }} 
                variant="filled"
                SelectDisplayProps={{
                  style: {paddingTop: "10px"}
                }}
                style={{width: "100%", maxWidth: "300px"}}
                displayEmpty
              >
                <MenuItem value={""} disabled>
                  Please select one of the following options
                </MenuItem> 
                { 
                  props.product?.options?.map(option => {

                    let optionDetails = "";

                    if (option.retail_price) {
                      optionDetails = "$" + option.retail_price?.toFixed(2);
                    }

                    if (option.is_promo_active) {
                      optionDetails = "$" + option.promotion_pricing.retail_price?.toFixed(2) + " (Promo)";
                    }

                    if (option.is_discontinued) {
                      optionDetails = "Discontinued";
                    } else if (option.is_ask_for_price) {
                      optionDetails = "Ask For Price";
                    } else if (option.is_call_for_price) {
                      optionDetails = "Call For Price";
                    }

                    if (option.uom) {
                      optionDetails += optionDetails !== "" ? ` - ${option.uom}` : option.uom;
                    }

                    if (option.basis_cd) {
                      optionDetails += optionDetails !== "" ? ` - ${option.basis_cd}` : option.basis_cd;
                    }

                    return (
                      <MenuItem key={option.cost_id} value={option.cost_id}>
                        <Typography variant="body2" color={option.is_discontinued ? "error" : "inherit"}>
                          <b>{option.color_name}</b>
                          <br></br>
                          {option.distributor}
                          <br></br>
                          <span style={{color: option.is_promo_active ? "#f44336" : "inherit"}}>{optionDetails}</span>
                        </Typography>
                      </MenuItem>
                    )
                  })
                }
              </Select>
            </>
          </Grid>
          { selectedOption ? (
              <>
                <Grid item xs={12}>
                  <ToggleButtonGroup
                    value={isOptionActive ? 'on' : 'off'}
                    exclusive
                    size='small'
                    onChange={(e, newValue) => handleIsProductOptionActiveChange(newValue)}
                    aria-label="text alignment"
                    style={{display: "inline-block", margin: "15px 0px 0px"}}
                  >
                    <ToggleButton value='on' aria-label="activate product" style={isOptionActive ? {width: "50px", backgroundColor: "#4caf50", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                      Yes
                    </ToggleButton>
                    <ToggleButton value='off' aria-label="discontinue product" style={!isOptionActive ? {width: "50px", backgroundColor: "#f44336", color: "#FFFFFF"} : {width: "50px", backgroundColor: "#00000017", color: "initial"}}>
                      No
                    </ToggleButton>
                  </ToggleButtonGroup>
                  <Typography variant="body1" style={{display: "inline-block", marginLeft: "10px"}}>
                    Is Option Active?
                  </Typography>
                  { discontinueDate && discontinueDate !== '9999-12-31' ? (
                      <>
                        <Typography style={{margin: "15px 0px 0px"}}>
                          Discontinue Date
                        </Typography>
                        <Typography>
                          {discontinueDate ? formatDate(discontinueDate, { fallback: '' }) : ''}
                        </Typography>
                      </>
                    ) : undefined
                  }

                  {/* TODO: Add this in later. Image link for each individual product SKU/cost Id */}
                  {/* <Typography style={{margin: "15px 0px 0px"}}>Product Option Image Link</Typography>
                  <TextField
                    name="image"
                    type="text"
                    label="Link to style option image"
                    value={optionImage || ''}
                    variant="filled"
                    fullWidth
                    onChange={(e) => setOptionImage(e.target.value)}
                  /> */}
                </Grid>
                {/* TODO: Add this in later. Image link for each individual product SKU/cost Id */}
                {/* <Grid item xs={12} style={{textAlign: "right"}}>
                  <Button
                    onClick={() => handleOptionSubmit()}
                    variant="contained"
                    style={{backgroundColor: "#4caf50", color: "#FFFFFF"}}
                  >
                    Update Option
                  </Button>
                </Grid> */}
              </>
            ) : undefined 
          }
          <Grid item xs={12} style={{textAlign: "right"}}>
            <Button
              onClick={() => clearDialog()}
              autoFocus
              variant="contained"
              style={{marginTop: "15px"}}
            >
              Close
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};